import React, { useEffect, useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import './Notifications.css';
import { connect } from 'react-redux';
import { NotificationsActions } from './Notifications.reducer';
import { ApiConstant, PageConstant, TitleConstant, FaviconAnimationListConstant } from '../../../constants';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import jwt from 'jsonwebtoken';
import io from 'socket.io-client';
import { Pagination, Spin } from 'antd';
import { pushLog2DV2LogServer } from '../../../services/logging';
import { gtmTag } from '../../legacy_components/util/gtmTag';
import withTestsService from '../../legacy_components/UI_V2_Components/tests/Tests.service';
import Favicon from 'react-favicon';
import _ from 'lodash';
import getEnv from '../../../services/util/getEnv';
import DOMPurify from 'dompurify'

const NotificationType = {
  // Notify user to take the seniority test (ASA)
  TAKE_SENIORITY_TEST: "TAKE_SENIORITY_TEST",
  // Notify user to take the 1st MCQ (any MCQ from their tech stacks)
  TAKE_1ST_MCQ: "TAKE_1ST_MCQ",
  // Notify user to complete their first tech stack
  PASS_TECH_STACK: "PASS_TECH_STACK",
  // Notify user to complete the Coding Challenge (ACC)
  TAKE_ACC: "TAKE_ACC",
  // Notify user to adjust their rate according to market rates
  RATE_ADJUSTMENT : "RATE_ADJUSTMENT",
  // Fast track flow - Notify to complete step 1: Update Availability
  FAST_TRACK_UPDATE_AVAILABILITY: "FAST_TRACK_UPDATE_AVAILABILITY",
  // Fast track flow - Notify to complete step 2: Take Quizzes
  FAST_TRACK_TAKE_MCQ: "FAST_TRACK_TAKE_MCQ",
  // Fast track flow - Notify to complete step 3: Take ACC
  FAST_TRACK_TAKE_ACC: "FAST_TRACK_TAKE_ACC",
  // Fast track flow - Notify to complete step 4: Update Profile
  FAST_TRACK_FINALIZE_PROFILE: "FAST_TRACK_FINALIZE_PROFILE",
  // Fast track flow - Notify to complete step 1: Complete MCQ
  FAST_TRACK_BAR_RAISER_MCQ: "FAST_TRACK_BAR_RAISER_MCQ",
  // Fast track flow - Notify to complete step 2: Complete ACC
  FAST_TRACK_BAR_RAISER_ACC: "FAST_TRACK_BAR_RAISER_ACC",
  // Fast track flow - Notify to complete step 3: Complete APT
  FAST_TRACK_BAR_RAISER_APT: "FAST_TRACK_BAR_RAISER_APT",
  // Fast track flow - Notify to complete step 4: Schedule Interview
  FAST_TRACK_BAR_RAISER_HYPERLINK: "FAST_TRACK_BAR_RAISER_HYPERLINK",

  // Fast track flow - Group notification for all fast tracks in ToFu. Notify to complete a fast track
  FAST_TRACK_TOFU_PENDING: "FAST_TRACK_TOFU_PENDING",

  // Soft skills notifications
  INVITE_SOFT_SKILLS: "INVITE_SOFT_SKILLS",

  // APT results are ready
  ASYNC_APT_SUBMISSION: "ASYNC_APT_SUBMISSION",
};

const NotificationStatus = {
  PENDING: 'PENDING',
  READ: 'READ',
  DONE: 'DONE'
};

const Notifications = (props) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [items, setItems] = useState([]);
  const [total, setTotalCount] = useState(0);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [faviconUrls, setFaviconUrls] = useState([]);
  const [faviconElements, setFaviconElements] = useState([]);
  let routerSubscribe = null;

  const {
    showWorkExpConfirmation
  } = props.testsService;

  useEffect(() => {
    const token = localStorage.getItem('token');
    const socket = io(getEnv("REACT_APP_SOCKET_ENDPOINT"), {
      transports: ['websocket', 'polling'],
      query: {
        notificationToken: token
      }
    });
    socket.connect();

    socket.on('notifications_update', () => {
      setCurrent(1);
      loadData(1);
    });

    routerSubscribe = props.history.listen((location) => {
      if (!location.pathname.includes('dashboard')) {
        resetBrowserTab();
      } else {
        loadData();
      }
    });
    return () => {
      if (routerSubscribe) {
        routerSubscribe();
      }
      resetBrowserTab();
    };
  }, []);

  useEffect(() => {
    if (+props.notificationsCount > 0) {
      animateBrowserTab(props.notificationsCount);
    } else if (document.title !== TitleConstant) {
      resetBrowserTab();
    }
  }, [props.notificationsCount]);

  useEffect(() => {
    if (faviconElements.length && !faviconUrls.length) {
      const currFavElements = document.querySelectorAll("link[rel*='icon']");
      currFavElements.forEach((el) => {
        el.remove();
      });
      faviconElements.forEach((el) => {
        document.head.appendChild(el);
      });
    }
  }, [faviconUrls]);

  const animateBrowserTab = (notificationCount) => {
    document.title = `(${notificationCount}) ${TitleConstant}`;
    const currFavElements = document.querySelectorAll("link[rel*='icon']");
    if (!faviconElements.length) {
      setFaviconElements(currFavElements);
    }
    setFaviconUrls(FaviconAnimationListConstant);
  }

  const resetBrowserTab = () => {
    setFaviconUrls([]);
    document.title = TitleConstant;
  }

  const initItem = (item) => {
    item.set = (data) => {
      setItems([...(items.map(elm => elm.id === item.id ? { ...item, ...data } : elm))]);
    };

    item.markAsRead = () => {
      const token = localStorage.getItem('token');
      const user = jwt.decode(token);
      pushLog2DV2LogServer.info(
        'DEVELOPER_NOTIFICATION',
        'NOTIFICATION_CLICK',
        {},
        {
          user_id: user.uid,
          user_email: user.email,
          notification_id: item.id,
          notification_type: item.type
        }
      );
      if (item.status === NotificationStatus.PENDING) {
        item.set({ loading: true });
        return new Promise(resolve => {
          axios.post(`${ApiConstant.BASE_URL}notifications/${item.id}/mark-as-read`)
            .catch(console.error)
            .finally(() => {
              loadData();
              item.set({ loading: false });
              resolve(true);
            });
        });
      } else {
        return Promise.resolve(true);
      }
    };

    item.click = () => {
      item.markAsRead().finally(() => {
        switch (item.type) {
          case NotificationType.TAKE_SENIORITY_TEST:
            showWorkExpConfirmation();
            break;
          case NotificationType.TAKE_1ST_MCQ:
          case NotificationType.PASS_TECH_STACK:
            props.history.push(PageConstant.GET_MULTI_CHOICES_CHALLENGE);
            break;
          case NotificationType.TAKE_ACC:
          case NotificationType.ASYNC_APT_SUBMISSION:
            props.history.push(PageConstant.CODING_CHALLENGE);
            break;
          case NotificationType.RATE_ADJUSTMENT:
            props.history.push(PageConstant.RATE_REFRESH);
            break;
          case NotificationType.INVITE_SOFT_SKILLS:
            props.history.push(PageConstant.SOFT_SKILLS);
            break;
          case NotificationType.FAST_TRACK_UPDATE_AVAILABILITY:
          case NotificationType.FAST_TRACK_TAKE_MCQ:
          case NotificationType.FAST_TRACK_TAKE_ACC:
          case NotificationType.FAST_TRACK_FINALIZE_PROFILE:
          case NotificationType.FAST_TRACK_BAR_RAISER_MCQ:
          case NotificationType.FAST_TRACK_BAR_RAISER_ACC:
          case NotificationType.FAST_TRACK_BAR_RAISER_APT:
          case NotificationType.FAST_TRACK_BAR_RAISER_HYPERLINK:
          case NotificationType.FAST_TRACK_TOFU_PENDING:
            props.history.push(PageConstant.FAST_TRACK_PAGE + '/' + item.related_resource_reference);
            break;
        }
        setNotificationStatus(false);
      });
    };
    return item;
  };

  items.map(initItem);
  const PAGE_SIZE = 3;
  const loadData = (page) => {
    if (!localStorage.getItem('token')) return;
    const start = ((page || 1) - 1) * PAGE_SIZE;
    setCurrent((page || 1));
    setLoading(true);
    axios.get(`${ApiConstant.BASE_URL}notifications?start=${start}&count=${PAGE_SIZE}`)
      .then(response => response.data)
      .then(({ code, data, totalCount, pendingCount }) => {
        if (code === 200) {
          if (Array.isArray(data)) {
            setItems(data.map(initItem));
          }
          setTotalCount(totalCount || 0);
          props.setNotificationsCount(pendingCount || 0);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (localStorage.getItem('token')) {
      loadData();
    }
  }, [localStorage.getItem('token') || '']);

  const setNotificationStatus = (open, mobile) => {
    if (mobile) {
      setPosition({ left: 20, top: 100 });
      document.body.classList.add('menu-notification-open');
    } else {
      const elem = document.querySelector('.menu-notification');
      if (open && elem) {
        setPosition({ left: window.screen.width - (window.screen.width - elem.parentNode.offsetLeft) - 406, top: elem.offsetTop + 50 });
        document.body.classList.add('menu-notification-open');
      } else {
        document.body.classList.remove('menu-notification-open');
      }
    }
    setVisible(open);
  };

  useEffect(() => {
    const notificationMenuClick = () => {
      setNotificationStatus(!visible, false);
    };

    const notificationMobileMenuClick = () => {
      setNotificationStatus(!visible, true);
    };

    const anyClick = (e) => {
      if (e && e.target && e.target.closest) {
        if (!e.target.closest('.NotificationsComponent') && visible) {
          setNotificationStatus(false);
        }
      }
    };

    window.addEventListener('vetting-menu-notification-click', notificationMenuClick);
    window.addEventListener('vetting-mobile-menu-notification-click', notificationMobileMenuClick);
    window.addEventListener('click', anyClick);
    return () => {
      window.removeEventListener('vetting-menu-notification-click', notificationMenuClick);
      window.removeEventListener('vetting-mobile-menu-notification-click', notificationMobileMenuClick);
      window.removeEventListener('click', anyClick);
    };
  }, [visible, setVisible, props.notificationsCount]);

  return (
    <>
      { faviconUrls.length > 0 ? <Favicon url={faviconUrls} /> : null }
      <div className={`NotificationsComponent ${visible ? 'NotificationsComponent-visible' : ''}`} style={position}>
        <Spin spinning={loading}>
          <div className="NotificationsComponent-list">
            {!loading && !total && !items.length ? <div className="NotificationsComponent-empty">No notifications yet.</div> : null}
            {items.map(item => <NotificationsItem key={item.id} item={item} />)}
            {total > PAGE_SIZE ? <Pagination size="small" current={current} total={total} pageSize={PAGE_SIZE} onChange={loadData} /> : null}
          </div>
        </Spin>
      </div>
    </>
  );
};

Notifications.propTypes = {
  store: PropTypes.any,
  notificationsCount: PropTypes.number,
  setNotificationsCount: PropTypes.func,
  dispatch: PropTypes.func
};

const NotificationsItem = ({ item }) => {
  return (
    <div className='NotificationsItem' onClick={item.click}>
      <span className={`NotificationsItem-dot NotificationsItem-dot-${(item.status || '').toLowerCase()}`} />
      <Spin spinning={!!item.loading}>
        {/* Using dangerouslySetInnerHTML is safe here as the notification description comes from a trusted source. We are also sanitzing using DOMPurify for additional security  */}
        <p className='NotificationsItem-text' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.description) }} />
        <span className='NotificationsItem-time'>{moment(item.created_date).format('ddd DD MMM - LT')}</span>
      </Spin>
      <span className='material-icons'>arrow_forward_ios</span>
    </div>
  );
};

NotificationsItem.propTypes = {
  item: PropTypes.any
};

Notifications.onMenuClick = (e) => {
  e.preventDefault();
  window.dispatchEvent(new Event('vetting-menu-notification-click'));
};

Notifications.onMobileMenuClick = (e) => {
  e.preventDefault();
  window.dispatchEvent(new Event('vetting-mobile-menu-notification-click'));
};

const mapStateToProps = (store) => ({ store, notificationsCount: (store && store.notifications && store.notifications.notifications_count) ? store.notifications.notifications_count : null });
const mapDispatchToProps = (dispatch) => ({ dispatch, setNotificationsCount: n => dispatch({ type: NotificationsActions.SET_NOTIFICATIONS_COUNT, payload: n }) });

Notifications.Badge = connect(mapStateToProps, mapDispatchToProps)((props) => {
  if (props.notificationsCount) {
    return <span className='menu-badge' data-testid="notifications-count">{props.notificationsCount}</span>;
  }
  return null;
});

Notifications.Badge.propTypes = {
  store: PropTypes.any,
  notificationsCount: PropTypes.number,
  setNotificationsCount: PropTypes.func,
  dispatch: PropTypes.func
};

export default withTestsService(connect(mapStateToProps, mapDispatchToProps)(withRouter(Notifications)));